// noinspection JSUnresolvedReference

(function(app) {
    const elements = {};
    
    app.ItalicToggle = {
        init() {
            elements.italicToggleEl = document.querySelector('.wdpp-checkbox--italic');
            elements.italicDisplayEl = document.querySelector('.wdpp-display--italic');
            
            // Validate required elements
            if (!app.Utils.validateElements('italic inputs', {
                'italic toggle checkbox': '.wdpp-checkbox--italic',
                'italic display element': '.wdpp-display--italic'
            })) {
                return;
            }

            elements.italicToggleEl.addEventListener('change', () => {
                app.Store.setState('italic', elements.italicToggleEl.checked);
            });

            app.Store.subscribe('initialized', () => {
                app.Store.setState('italic', elements.italicToggleEl.checked);
            });

            // Subscribe to store changes
            app.Store.subscribe('italic', (value) => this.updateItalicDisplay(value));
        },

        updateItalicDisplay(isChecked) {
            if (elements.italicDisplayEl) {
                elements.italicDisplayEl.textContent = isChecked ? 'Ja' : 'Nej';
                elements.italicDisplayEl.classList.toggle('is-true', isChecked);
                elements.italicDisplayEl.classList.toggle('is-false', !isChecked);
            }
        },
        
        /**
         * Get the italic data for cart export
         * @returns {object} The italic data for the cart
         */
        getCartData() {
            return {
                italic: app.Store.getState('italic') || false,
            };
        },

        /**
         * Get the italic data for price calculation
         * @returns {object} The italic data for the price
         */
        getPriceData() {
            return {
                italic: app.Store.getState('italic') || false,
            };
        },
    };
})(window.app = window.app || {});